import React from 'react';
import { useTranslation } from './i18n';

export default function CookieverklaringPage({ onBack }) {
  const { t } = useTranslation();

  const browserLinks = [
    { label: t('cookie_page.browser_links.chrome'), href: 'https://support.google.com/chrome/answer/95647' },
    { label: t('cookie_page.browser_links.firefox'), href: 'https://support.mozilla.org/nl/kb/cookies-verwijderen-gegevens-wissen-websites-opges' },
    { label: t('cookie_page.browser_links.safari'), href: 'https://support.apple.com/nl-nl/guide/safari/sfri11471/mac' },
    { label: t('cookie_page.browser_links.edge'), href: 'https://support.microsoft.com/nl-nl/microsoft-edge/cookies-verwijderen-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#447863] text-white py-6">
        <div className="max-w-4xl mx-auto px-6">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-white/80 hover:text-white mb-4 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            {t('cookie_page.back_home')}
          </button>
          <h1 className="text-3xl font-bold">{t('cookie_page.title')}</h1>
          <p className="text-white/80 mt-2">{t('cookie_page.version')}</p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8">
          <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-r-lg">
            <h2 className="text-xl font-semibold text-green-800 mb-2">{t('cookie_page.sections.intro.title')}</h2>
            <p className="text-green-700">{t('cookie_page.sections.intro.body')}</p>
          </div>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookie_page.sections.cookies.title')}</h2>

            <div className="space-y-6">
              <div className="border rounded-lg p-5">
                <h3 className="font-semibold text-gray-900 flex items-center gap-2">{t('cookie_page.sections.cookies.functional.title')}</h3>
                <p className="text-gray-600 mt-2 mb-4">{t('cookie_page.sections.cookies.functional.body')}</p>
                <table className="w-full text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="text-left p-2 font-medium">{t('cookie_page.sections.cookies.table.cookie')}</th>
                      <th className="text-left p-2 font-medium">{t('cookie_page.sections.cookies.table.purpose')}</th>
                      <th className="text-left p-2 font-medium">{t('cookie_page.sections.cookies.table.retention')}</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    <tr>
                      <td className="p-2 font-mono text-xs">access_candidate</td>
                      <td className="p-2">{t('cookie_page.sections.cookies.functional.row_1_purpose')}</td>
                      <td className="p-2">{t('cookie_page.sections.cookies.functional.row_1_retention')}</td>
                    </tr>
                    <tr>
                      <td className="p-2 font-mono text-xs">access_company</td>
                      <td className="p-2">{t('cookie_page.sections.cookies.functional.row_2_purpose')}</td>
                      <td className="p-2">{t('cookie_page.sections.cookies.functional.row_2_retention')}</td>
                    </tr>
                    <tr>
                      <td className="p-2 font-mono text-xs">auth_token</td>
                      <td className="p-2">{t('cookie_page.sections.cookies.functional.row_3_purpose')}</td>
                      <td className="p-2">{t('cookie_page.sections.cookies.functional.row_3_retention')}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="border rounded-lg p-5">
                <h3 className="font-semibold text-gray-900 flex items-center gap-2">{t('cookie_page.sections.cookies.analytics.title')}</h3>
                <p className="text-gray-600 mt-2 mb-4">{t('cookie_page.sections.cookies.analytics.body')}</p>
                <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
                  <li>{t('cookie_page.sections.cookies.analytics.item_1')}</li>
                  <li>{t('cookie_page.sections.cookies.analytics.item_2')}</li>
                  <li>{t('cookie_page.sections.cookies.analytics.item_3')}</li>
                  <li>{t('cookie_page.sections.cookies.analytics.item_4')}</li>
                  <li>{t('cookie_page.sections.cookies.analytics.item_5')}</li>
                </ul>
                <p className="text-gray-600 mt-4">{t('cookie_page.sections.cookies.analytics.outro')}</p>
              </div>

              <div className="border rounded-lg p-5 bg-gray-50">
                <h3 className="font-semibold text-gray-900 flex items-center gap-2">{t('cookie_page.sections.cookies.tracking.title')}</h3>
                <p className="text-gray-600 mt-2">{t('cookie_page.sections.cookies.tracking.body')}</p>
                <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4 mt-2">
                  <li>{t('cookie_page.sections.cookies.tracking.item_1')}</li>
                  <li>{t('cookie_page.sections.cookies.tracking.item_2')}</li>
                  <li>{t('cookie_page.sections.cookies.tracking.item_3')}</li>
                  <li>{t('cookie_page.sections.cookies.tracking.item_4')}</li>
                  <li>{t('cookie_page.sections.cookies.tracking.item_5')}</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookie_page.sections.banner.title')}</h2>
            <p className="text-gray-600">{t('cookie_page.sections.banner.body_1')}</p>
            <p className="text-gray-600 mt-4">{t('cookie_page.sections.banner.body_2')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookie_page.sections.manage.title')}</h2>
            <p className="text-gray-600">{t('cookie_page.sections.manage.body')}</p>
            <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4 mt-4">
              {browserLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-[#447863] hover:underline">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="text-gray-500 text-sm mt-4">{t('cookie_page.sections.manage.outro')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookie_page.sections.local_storage.title')}</h2>
            <p className="text-gray-600">{t('cookie_page.sections.local_storage.body')}</p>
            <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4 mt-4">
              <li>{t('cookie_page.sections.local_storage.item_1')}</li>
              <li>{t('cookie_page.sections.local_storage.item_2')}</li>
              <li>{t('cookie_page.sections.local_storage.item_3')}</li>
            </ul>
          </section>

          <section className="border-t pt-8 mt-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookie_page.sections.contact.title')}</h2>
            <p className="text-gray-600">{t('cookie_page.sections.contact.body')}</p>
            <p className="mt-4">
              <a href="mailto:info@betaaldsolliciteren.nl" className="text-[#447863] hover:underline font-medium">
                info@betaaldsolliciteren.nl
              </a>
            </p>
          </section>

          <section className="bg-gray-50 rounded-lg p-6 mt-8">
            <h3 className="font-semibold text-gray-900 mb-3">{t('cookie_page.related.title')}</h3>
            <div className="flex flex-wrap gap-4">
              <a href="/privacy" className="text-[#447863] hover:underline">{t('cookie_page.related.privacy')}</a>
              <a href="/voorwaarden" className="text-[#447863] hover:underline">{t('cookie_page.related.terms')}</a>
              <a href="/ai-policy" className="text-[#447863] hover:underline">{t('cookie_page.related.ai_policy')}</a>
            </div>
          </section>

        </div>
      </main>

      <footer className="bg-gray-900 text-white py-8 mt-12">
        <div className="max-w-4xl mx-auto px-6 text-center text-gray-400">
          {t('cookie_page.footer', { year: new Date().getFullYear() })}
        </div>
      </footer>
    </div>
  );
}
